import MapRepository from "../../interfaces/gateways/map.repository";
import CourtEntity from "../../../courts/entities/court.entity";
import CourtsApiGateway from "../../interfaces/gateways/courts-api.gateway";

export default class SelectCourtCase {
  constructor (
    private readonly mapRepository: MapRepository,
    private readonly courtsApiGateway: CourtsApiGateway
  ) {
  }

  async execute (c: CourtEntity | null): Promise<void> {
    if (c !== null) {
      let court = this.mapRepository.getSingleCourt(c.id)
      if (court === undefined) {
        const courtApiModel = await this.courtsApiGateway.loadCourt(c.id)
        court = new CourtEntity()
        court.fromAPIModel(courtApiModel)
      }
      this.mapRepository.selectCourt(court)
      this.mapRepository.showPopup(true)
    } else {
      this.mapRepository.showPopup(false)
    }
  }
}
